import HowItWorks from '@/components/HowItWorks';
import Footer from '@/components/Footer';

export default function HowItWorksPage() {
  return (
    <div className="pt-20">
      <HowItWorks />
      <Footer />
    </div>
  );
}
